import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

import { HrApplicantStatus, RepositoryModal } from '../../../shared'

@Component({
    templateUrl: './hr-applicant-status.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent],
})
export class HrApplicantStatusComponent extends RepositoryModal<HrApplicantStatus> {}
